module.exports = __webpack_public_path__ + "img/product_126.bdcf8f1.webp";